@if (listImages.length != 0) {

    <div class="text-2xl font-semibold text-center mb-4 items-center justify-center">
        <div class="my-4">
            <h2 class="text-3xl">
                {{ texts.title }}
            </h2>
        </div>
        <div class="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
            <swiper-container
                navigation="true"
                pagination="false"
                loop="true"
                autoplay-delay="2500"
                autoplay-disable-on-interaction="false"
                style="width:100%;height:150px;display:block;"
                #swiperEl
            >
            <swiper-slide *ngFor="let img of listImages">
                <img [src]="img.url || img" alt="Partner" style="width:100%;height:100%;object-fit:contain;"  (click)="openurl(img.description)" class="hover:cursor-pointer"/>
            </swiper-slide>
            </swiper-container>
        </div>
    </div>
}


